/**
 * EmptyState — shown when there is nothing to render (no manifest, empty
 * domain, no search results). Always offers context, never a blank pane.
 */
import { Icon } from './Icon.js';

export interface EmptyStateProps {
  icon: string;
  title: string;
  detail?: string;
  children?: React.ReactNode;
}

export function EmptyState({ icon, title, detail, children }: EmptyStateProps): React.JSX.Element {
  return (
    <div className="empty-state" role="status">
      <Icon name={icon} size="xl" />
      <strong style={{ color: 'var(--text2)' }}>{title}</strong>
      {detail && <span>{detail}</span>}
      {children}
    </div>
  );
}
